import React, { FC, SVGProps, useEffect, useState } from 'react'
import { ReactComponent as IconCustomAdd } from './icons/custom-add.svg'
import { ReactComponent as IconCustomEdit } from './icons/custom-edit.svg'
import { ReactComponent as IconCustomDelete } from './icons/custom-delete.svg'
import { ReactComponent as IconCustomExpandLess } from './icons/custom-expand-less.svg'
import { ReactComponent as IconCustomExpandMore } from './icons/custom-expand-more.svg'
import { ReactComponent as IconCustomFullscreen } from './icons/custom-fullscreen.svg'
import { ReactComponent as IconCustomFullscreenExit } from './icons/custom-fullscreen-exit.svg'
import { ReactComponent as IconCustomExit } from './icons/custom-exit.svg'
import { ReactComponent as IconCustomComment } from './icons/custom-comment.svg'
import { ReactComponent as IconCustomAlert } from './icons/custom-alert.svg'
import { ReactComponent as IconCustomCircleArrowLeft } from './icons/custom-circle-arrow-left.svg'
import { ReactComponent as IconCustomCircleArrowRight } from './icons/custom-circle-arrow-right.svg'
import { ReactComponent as IconCustomPriority } from './icons/custom-priority.svg'
import { ReactComponent as IconCustomArchive } from './icons/custom-archive.svg'
import { ReactComponent as IconCustomSearchFilter } from './icons/custom-search-filter.svg'
import { ReactComponent as IconCustomCircleClose } from './icons/custom-circle-close.svg'
import { ReactComponent as IconCustomCalculate } from './icons/custom-calculate.svg'
import { ReactComponent as IconCustomToComment } from './icons/custom-to-comment.svg'
import { ReactComponent as IconCustomLooks0 } from './icons/custom-looks-0.svg'
import { ReactComponent as IconCustomLooks1 } from './icons/custom-looks-1.svg'
import { ReactComponent as IconCustomLooks2 } from './icons/custom-looks-2.svg'
import { ReactComponent as IconCustomLooks3 } from './icons/custom-looks-3.svg'
import { ReactComponent as IconCustomLooks4 } from './icons/custom-looks-4.svg'
import { ReactComponent as IconCustomLooks5 } from './icons/custom-looks-5.svg'
import { ReactComponent as IconCustomHelp } from './icons/custom-help.svg'
import { ReactComponent as IconCustomInfo } from './icons/custom-info.svg'
import { ReactComponent as IconCustomDownload } from './icons/custom-download.svg'
import { ReactComponent as IconCustomSettings } from './icons/custom-settings.svg'
import { ReactComponent as IconCustomFolder } from './icons/custom-folder.svg'
import { ReactComponent as IconCustomSync } from './icons/custom-sync.svg'
import { ReactComponent as IconCustomUnfoldLess } from './icons/custom-unfold-less.svg'
import { ReactComponent as IconCustomUnfoldMore } from './icons/custom-unfold-more.svg'
import { ReactComponent as IconCustomSave } from './icons/custom-save.svg'
import { ReactComponent as IconCustomCloudUpload } from './icons/custom-cloud-upload.svg'
import { ReactComponent as IconCustomExpandCircleDown } from './icons/custom-expand-circle-down.svg'
import { ReactComponent as IconCustomExpandCircleUp } from './icons/custom-expand-circle-up.svg'
import { ReactComponent as IconCustomMenu } from './icons/custom-menu.svg'
import { ReactComponent as IconCustomClose } from './icons/custom-close.svg'
import { ReactComponent as IconCustomAttachFile } from './icons/custom-attach-file.svg'
import { ReactComponent as IconEditFormatAlignCenter } from './icons/edit-format-align-center.svg'
import { ReactComponent as IconEditFormatAlignJustify } from './icons/edit-format-align-justify.svg'
import { ReactComponent as IconEditFormatAlignLeft } from './icons/edit-format-align-left.svg'
import { ReactComponent as IconEditFormatAlignRight } from './icons/edit-format-align-right.svg'
import { ReactComponent as IconEditFormatBold } from './icons/edit-format-bold.svg'
import { ReactComponent as IconEditFormatClear } from './icons/edit-format-clear.svg'
import { ReactComponent as IconEditFormatItalic } from './icons/edit-format-italic.svg'
import { ReactComponent as IconEditFormatStrikethrough } from './icons/edit-format-strikethrough.svg'
import { ReactComponent as IconEditFormatUnderlined } from './icons/edit-format-underlined.svg'
import { ReactComponent as IconEditSelectAll } from './icons/edit-select-all.svg'
import { ReactComponent as IconEditContentCopy } from './icons/edit-content-copy.svg'
import { ReactComponent as IconEditCut } from './icons/edit-cut.svg'
import { ReactComponent as IconEditDelete } from './icons/edit-delete.svg'
import { ReactComponent as IconEditRedo } from './icons/edit-redo.svg'
import { ReactComponent as IconEditUndo } from './icons/edit-undo.svg'
import { ReactComponent as IconEditFormatH1 } from './icons/edit-format-h1.svg'
import { ReactComponent as IconEditFormatH2 } from './icons/edit-format-h2.svg'
import { ReactComponent as IconEditFormatH3 } from './icons/edit-format-h3.svg'
import { ReactComponent as IconEditFormatListBulleted } from './icons/edit-format-list-bulleted.svg'
import { ReactComponent as IconEditFormatListNumbered } from './icons/edit-format-list-numbered.svg'
import { ReactComponent as IconEditFormatParagraph } from './icons/edit-format-paragraph.svg'
import { ReactComponent as IconEditFormatQuote } from './icons/edit-format-quote.svg'
import { ReactComponent as IconEditHorizontalRule } from './icons/edit-horizontal-rule.svg'
import { ReactComponent as IconEditSubscript } from './icons/edit-subscript.svg'
import { ReactComponent as IconEditSuperscript } from './icons/edit-superscript.svg'
import { ReactComponent as IconCustomEyeSolid } from './icons/custom-eye-solid.svg'
import { ReactComponent as IconCustomEyeSlashSolid } from './icons/custom-eye-slash-solid.svg'
import { ReactComponent as IconEditAddPhotoAlternate } from './icons/edit-add-photo-alternate.svg'
import { ReactComponent as IconEditImage } from './icons/edit-image.svg'
import { ReactComponent as IconEditLink } from './icons/edit-link.svg'
import { ReactComponent as IconEditLinkOff } from './icons/edit-link-off.svg'
import { ReactComponent as IconEditMovie } from './icons/edit-movie.svg'
import { ReactComponent as IconEditYoutubeActivity } from './icons/edit-youtube-activity.svg'
import { ReactComponent as IconEditTable } from './icons/edit-table.svg'
import { ReactComponent as IconCustomChangeCircle } from './icons/custom-change-circle.svg'
import { ReactComponent as IconCustomSwapVert } from './icons/custom-swap-vert.svg'
import { ReactComponent as IconCustomWorkspacePremium } from './icons/custom-workspace-premium.svg'
import { ReactComponent as IconCustomAwardStar } from './icons/custom-award-star.svg'

import { ReactComponent as IconLineContractDelete } from './icons/line-contract-delete.svg'
import { ReactComponent as IconLineContract } from './icons/line-contract.svg'
import { ReactComponent as IconLineEvent } from './icons/line-event.svg'
import { ReactComponent as IconLineFreeCancellation } from './icons/line-free-cancellation.svg'
import { ReactComponent as IconLineHelp } from './icons/line-help.svg'
import { ReactComponent as IconLineLabProfile } from './icons/line-lab-profile.svg'
import { ReactComponent as IconLineNoteStackAdd } from './icons/line-note-stack-add.svg'
import { ReactComponent as IconLineReceiptLong } from './icons/line-receipt-long.svg'
import { ReactComponent as IconLineTask } from './icons/line-task.svg'
import { ReactComponent as IconLineTaskAlt } from './icons/line-task-alt.svg'
import { ReactComponent as IconLineUnknownDocument } from './icons/line-unknown-document.svg'

import { ReactComponent as IconCustomAccountCircle } from './icons/custom-account-circle.svg'

import { ReactComponent as IconCustomCircleBad } from './icons/custom-circle-bad.svg'
import { ReactComponent as IconCustomCircleGood } from './icons/custom-circle-good.svg'

import { ReactComponent as IconCurrencyDollar } from './icons/currency-dollar.svg'
import { ReactComponent as IconCurrencyYuan } from './icons/currency-yuan.svg'
import { ReactComponent as IconCurrencyRuble } from './icons/currency-ruble.svg'

import { ReactComponent as IconCustomStar } from './icons/custom-star.svg'

import { IconProps } from './Icon'

interface IIconViewProps {
  size: number
  view: JSX.Element
}

export type IconViewProps = IIconViewProps

export const useIcon = (props: IconProps): IconViewProps => {
  const [view, setView] = useState<JSX.Element>(null)

  useEffect(() => {
    return () => {
      setView(null)
    }
  }, [])

  useEffect(() => {
    setView(getView(props.name, props.color, props.size))
  }, [props.name, props.color, props.size])

  const getElement = (name: string): FC<SVGProps<SVGSVGElement>> => {
    switch (name) {
      case 'custom-add':
        return IconCustomAdd
      case 'custom-edit':
        return IconCustomEdit
      case 'custom-delete':
        return IconCustomDelete

      case 'custom-expand-less':
        return IconCustomExpandLess
      case 'custom-expand-more':
        return IconCustomExpandMore

      case 'custom-exit':
        return IconCustomExit
      case 'custom-comment':
        return IconCustomComment
      case 'custom-alert':
        return IconCustomAlert

      case 'custom-circle-arrow-left':
        return IconCustomCircleArrowLeft
      case 'custom-circle-arrow-right':
        return IconCustomCircleArrowRight

      case 'custom-fullscreen':
        return IconCustomFullscreen
      case 'custom-fullscreen-exit':
        return IconCustomFullscreenExit

      case 'custom-priority':
        return IconCustomPriority
      case 'custom-archive':
        return IconCustomArchive
      case 'custom-search-filter':
        return IconCustomSearchFilter
      case 'custom-circle-close':
        return IconCustomCircleClose

      case 'custom-calculate':
        return IconCustomCalculate
      case 'custom-to-comment':
        return IconCustomToComment

      case 'custom-looks-0':
        return IconCustomLooks0
      case 'custom-looks-1':
        return IconCustomLooks1
      case 'custom-looks-2':
        return IconCustomLooks2
      case 'custom-looks-3':
        return IconCustomLooks3
      case 'custom-looks-4':
        return IconCustomLooks4
      case 'custom-looks-5':
        return IconCustomLooks5

      case 'custom-help':
        return IconCustomHelp
      case 'custom-info':
        return IconCustomInfo

      case 'custom-download':
        return IconCustomDownload

      case 'custom-settings':
        return IconCustomSettings
      case 'custom-folder':
        return IconCustomFolder

      case 'custom-sync':
        return IconCustomSync
      case 'custom-unfold-less':
        return IconCustomUnfoldLess
      case 'custom-unfold-more':
        return IconCustomUnfoldMore

      case 'custom-save':
        return IconCustomSave

      case 'custom-cloud-upload':
        return IconCustomCloudUpload

      case 'custom-expand-circle-down':
        return IconCustomExpandCircleDown
      case 'custom-expand-circle-up':
        return IconCustomExpandCircleUp

      case 'custom-menu':
        return IconCustomMenu
      case 'custom-close':
        return IconCustomClose

      case 'custom-attach-file':
        return IconCustomAttachFile

      case 'edit-format-align-center':
        return IconEditFormatAlignCenter
      case 'edit-format-align-justify':
        return IconEditFormatAlignJustify
      case 'edit-format-align-left':
        return IconEditFormatAlignLeft
      case 'edit-format-align-right':
        return IconEditFormatAlignRight

      case 'edit-format-bold':
        return IconEditFormatBold
      case 'edit-format-italic':
        return IconEditFormatItalic
      case 'edit-format-strikethrough':
        return IconEditFormatStrikethrough
      case 'edit-format-underlined':
        return IconEditFormatUnderlined

      case 'edit-select-all':
        return IconEditSelectAll
      case 'edit-format-clear':
        return IconEditFormatClear
      case 'edit-content-copy':
        return IconEditContentCopy
      case 'edit-cut':
        return IconEditCut
      case 'edit-delete':
        return IconEditDelete
      case 'edit-redo':
        return IconEditRedo
      case 'edit-undo':
        return IconEditUndo

      case 'edit-format-h1':
        return IconEditFormatH1
      case 'edit-format-h2':
        return IconEditFormatH2
      case 'edit-format-h3':
        return IconEditFormatH3
      case 'edit-format-paragraph':
        return IconEditFormatParagraph
      case 'edit-format-quote':
        return IconEditFormatQuote

      case 'edit-format-list-bulleted':
        return IconEditFormatListBulleted
      case 'edit-format-list-numbered':
        return IconEditFormatListNumbered

      case 'edit-horizontal-rule':
        return IconEditHorizontalRule

      case 'edit-subscript':
        return IconEditSubscript
      case 'edit-superscript':
        return IconEditSuperscript

      case 'custom-eye-solid':
        return IconCustomEyeSolid
      case 'custom-eye-slash-solid':
        return IconCustomEyeSlashSolid

      case 'edit-add-photo-alternate':
        return IconEditAddPhotoAlternate
      case 'edit-image':
        return IconEditImage
      case 'edit-link':
        return IconEditLink
      case 'edit-link-off':
        return IconEditLinkOff
      case 'edit-movie':
        return IconEditMovie
      case 'edit-youtube-activity':
        return IconEditYoutubeActivity

      case 'edit-table':
        return IconEditTable

      case 'custom-change-circle':
        return IconCustomChangeCircle
      case 'custom-swap-ver':
        return IconCustomSwapVert

      case 'custom-workspace-premium':
        return IconCustomWorkspacePremium
      case 'custom-award-star':
        return IconCustomAwardStar

      case 'line-contract-delete':
        return IconLineContractDelete
      case 'line-contract':
        return IconLineContract
      case 'line-event':
        return IconLineEvent
      case 'line-free-cancellation':
        return IconLineFreeCancellation
      case 'line-help':
        return IconLineHelp
      case 'line-lab-profile':
        return IconLineLabProfile
      case 'line-note-stack-add':
        return IconLineNoteStackAdd
      case 'line-receipt-long':
        return IconLineReceiptLong
      case 'line-task':
        return IconLineTask
      case 'line-task-alt':
        return IconLineTaskAlt
      case 'line-unknown-document':
        return IconLineUnknownDocument

      case 'custom-account-circle':
        return IconCustomAccountCircle

      case 'custom-circle-bad':
        return IconCustomCircleBad
      case 'custom-circle-good':
        return IconCustomCircleGood

      case 'currency-dollar':
        return IconCurrencyDollar
      case 'currency-yuan':
        return IconCurrencyYuan
      case 'currency-ruble':
        return IconCurrencyRuble

      case 'custom-star':
        return IconCustomStar

      default:
        return null
    }
  }

  const getIcon = (Icon: FC<SVGProps<SVGSVGElement>>, color: string, width: string, height: string): JSX.Element => (
    <Icon fill={color} width={width} height={height}/>
  )

  const getView = (name: string, color: string, size: number): JSX.Element => {
    const width = String(size) + 'px'
    const height = String(size) + 'px'

    return !!getElement(name) && getIcon(getElement(name), color, width, height)
  }

  return {
    size: props.size,
    view
  }
}
